export function getChildIndexById(id, descendants) {
  return descendants.findIndex(function (descendant) {
    return descendant.id === id;
  });
}
export function getChildById(id, descendants) {
  return descendants.find(function (descendant) {
    return descendant.id === id;
  });
}
/**
 * Find the first enabled descendant.
 */

export function getFirstEnabledChildIndex(descendants) {
  return descendants.findIndex(function (descendant) {
    return !descendant.element.current.hasAttribute('disabled');
  });
}
/**
 * Find the last enabled descendant.
 */

export function getLastEnabledChildIndex(descendants) {
  // eslint-disable-next-line no-plusplus
  for (var i = descendants.length - 1; i >= 0; i--) {
    if (!descendants[i].element.current.hasAttribute('disabled')) {
      return i;
    }
  }

  return -1;
}
/**
 * Find the next enabled child.
 */

export function getNextEnabledChild(currentId, descendants) {
  if (!currentId) {
    return descendants[getFirstEnabledChildIndex(descendants)];
  }

  var currentIndex = descendants.findIndex(function (_ref) {
    var id = _ref.id;
    return id === currentId;
  });
  var nextIndex = getNextEnabledIndex(currentIndex, descendants);
  return descendants[nextIndex];
}
/**
 * Using an index, get the next enabled child
 */

export function getNextEnabledIndex(index, descendants) {
  var nextIndex = Math.min(index + 1, getLastEnabledChildIndex(descendants));
  return descendants[nextIndex].element.current.hasAttribute('disabled') ? getNextEnabledIndex(nextIndex, descendants) : nextIndex;
}
/**
 * Find the previously enabled child.
 */

export function getPrevEnabledChild(currentId, descendants) {
  if (!currentId) {
    return descendants[getLastEnabledChildIndex(descendants)];
  }

  var currentIndex = descendants.findIndex(function (_ref2) {
    var id = _ref2.id;
    return id === currentId;
  });
  var prevIndex = getPrevEnabledIndex(currentIndex, descendants);
  return descendants[prevIndex];
}
/**
 * Find the previously enabled child given an index
 */

export function getPrevEnabledIndex(index, descendants) {
  var prevIndex = Math.max(index - 1, getFirstEnabledChildIndex(descendants));
  return descendants[prevIndex].element.current.hasAttribute('disabled') ? getPrevEnabledIndex(prevIndex, descendants) : prevIndex;
}
/**
 * Find the first element that contains text which starts
 * with the provided query. Used for typeahead functionality.
 */

export function findItemFromTypeahead(descendants) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!query) {
    return null;
  }

  return descendants.find(function (_ref3) {
    var element = _ref3.element;
    return element.current.textContent.toLowerCase().startsWith(query) && !element.current.hasAttribute('disabled');
  });
}